import { render, staticRenderFns } from "./workout-achievements-list.vue?vue&type=template&id=4f6abf34&"
import script from "./workout-achievements-list.vue?vue&type=script&lang=js&"
export * from "./workout-achievements-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports